module.exports = __webpack_public_path__ + "img/0-91.f3304672.jpg";